import { render, staticRenderFns } from "./suport.vue?vue&type=template&id=c0349e30&scoped=true"
import script from "./suport.vue?vue&type=script&lang=js"
export * from "./suport.vue?vue&type=script&lang=js"
import style0 from "./suport.vue?vue&type=style&index=0&id=c0349e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0349e30",
  null
  
)

export default component.exports